import API from "serviceshift-ui/api-client";

export default {
  createPO({ commit }, { jobId, data }) {
    return API.makeRequest(`/v2/jobs/${jobId}/purchase_orders`, {
      method: "POST",
      data,
      params: { item_grouping: 1 }
    }).then((res) => {
      commit("replace", {
        state: "job",
        data: res.data,
      });
    });
  },
  fetchPO(_, { id, jobId }) {
    return API.makeRequest(`/v2/jobs/${jobId}/purchase_orders/${id}`, {
      method: "GET",
    });
  },
  updatePO({ commit }, { jobId, data }) {
    return API.makeRequest(
      `/v2/jobs/${jobId}/purchase_orders/${data.purchase_order.purchase_order_id}`,
      {
        method: "PUT",
        data,
        params: { item_grouping: 1 }
      }
    ).then((res) => {
      commit("replace", {
        state: "job",
        data: res.data,
      });
    });
  },
};
